var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"router-link-button",attrs:{"label":_vm.label,"to":_vm.to},nativeOn:{"click":function($event){return _vm.navigate($event)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }